import React from "react";

/**
 * Shared upload / compress progress UI: status text, percent, and bar.
 */
export default function UploadProgressBar({
  status = "Working…",
  progress = 0,
  hint = "Please keep this window open while your photos or videos upload.",
  onCancel = null,
}) {
  const pct = Math.max(0, Math.min(100, Math.round(Number(progress) || 0)));

  return (
    <div
      style={{
        marginTop: 8,
        marginBottom: 10,
        padding: "12px 14px",
        borderRadius: 12,
        background: "rgba(248, 250, 252, 0.98)",
        border: "1px solid rgba(148, 163, 184, 0.55)",
        boxShadow: "inset 0 1px 2px rgba(148,163,184,0.25)",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 10,
          marginBottom: 8,
        }}
      >
        <span
          style={{
            fontSize: 13,
            color: "#334155",
            fontWeight: 500,
            minWidth: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {status || "Working…"}
        </span>
        <span
          style={{
            fontSize: 14,
            fontWeight: 700,
            color: "#0284c7",
            flexShrink: 0,
            fontVariantNumeric: "tabular-nums",
          }}
        >
          {pct}%
        </span>
      </div>
      <div
        style={{
          height: 12,
          borderRadius: 999,
          background: "#e2e8f0",
          overflow: "hidden",
        }}
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={pct}
        aria-label="Upload progress"
      >
        <div
          style={{
            height: "100%",
            width: `${pct}%`,
            borderRadius: 999,
            background: "linear-gradient(90deg, #0ea5e9, #6366f1, #22c55e)",
            transition: "width 0.2s ease-out",
          }}
        />
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 10,
          marginTop: 8,
        }}
      >
        {hint ? (
          <p
            style={{
              margin: 0,
              fontSize: 11,
              color: "#94a3b8",
              flex: 1,
            }}
          >
            {hint}
          </p>
        ) : (
          <span />
        )}
        {typeof onCancel === "function" ? (
          <button
            type="button"
            onClick={onCancel}
            style={{
              flexShrink: 0,
              border: "1px solid #cbd5e1",
              background: "#fff",
              color: "#b91c1c",
              borderRadius: 8,
              padding: "6px 10px",
              fontSize: 12,
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Cancel upload
          </button>
        ) : null}
      </div>
    </div>
  );
}
